function ayarla() {
    ////alert($('#exImg').width());
    if ($(window).width() < 980) {

    }
    else {
        $('.absolute').css({
            "max-width": "none"
        });
        var yukseklik = (($('.shopCol').height()) - 45) / 2;
        $('.exImg').css({
            "height": yukseklik + "px"
        });
        $('.newsImg').css({
            "height": yukseklik + "px"
        });
    }
}
jQuery(document).ready(function ($) {
    ayarla();
});
$(window).bind('resize', function () {
    ayarla();
    mainCont();
});
function getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
}
function mainCont(){
    var winH=$(window).height(),
        headerH=$(".headerCon").height(),
        footerH=$("footer").height();
    $(".main-content").css({
        //"padding-top":headerH+15+"px"
    });
}
$(window).load(function () {
    $(window).trigger('resize');
});



// Plugin: jQuery.mousetip
// Source: github.com/nathco/jQuery.mousetip
// Author: Nathan Rutzky
// Update: 1.00

$.fn.mousetip = function(tip, x, y) {

    var $this = $(this);

    $this.hover(function() {

        $(tip).show();

    }, function() {

        $(tip).hide().removeAttr('style');

    }).mousemove(function(e) {

        var mouseX = e.pageX + (x || 10);
        var mouseY = e.pageY + (y || 10);

        $(tip).show().css({

            top:mouseY, left:mouseX

        });
    });
};



(function(c,n){var l="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";c.fn.imagesLoadeds=function(f){function m(){var b=c(i),a=c(h);d&&(h.length?d.reject(e,b,a):d.resolve(e));c.isFunction(f)&&f.call(g,e,b,a)}function j(b,a){b.src===l||-1!==c.inArray(b,k)||(k.push(b),a?h.push(b):i.push(b),c.data(b,"imagesLoaded",{isBroken:a,src:b.src}),o&&d.notifyWith(c(b),[a,e,c(i),c(h)]),e.length===k.length&&(setTimeout(m),e.unbind(".imagesLoaded")))}var g=this,d=c.isFunction(c.Deferred)?c.Deferred():
    0,o=c.isFunction(d.notify),e=g.find("img").add(g.filter("img")),k=[],i=[],h=[];c.isPlainObject(f)&&c.each(f,function(b,a){if("callback"===b)f=a;else if(d)d[b](a)});e.length?e.bind("load.imagesLoaded error.imagesLoaded",function(b){j(b.target,"error"===b.type)}).each(function(b,a){var d=a.src,e=c.data(a,"imagesLoaded");if(e&&e.src===d)j(a,e.isBroken);else if(a.complete&&a.naturalWidth!==n)j(a,0===a.naturalWidth||0===a.naturalHeight);else if(a.readyState||a.complete)a.src=l,a.src=d}):m();return d?d.promise(g):
    g}})(jQuery);

/**
 * imagefill.js
 * Author & copyright (c) 2013: John Polacek
 * johnpolacek.com
 * https://twitter.com/johnpolacek
 *
 * Dual MIT & GPL license
 *
 * Project Page: http://johnpolacek.github.io/imagefill.js
 *
 * The jQuery plugin for making images fill their containers (and be centered)
 *
 * EXAMPLE
 * Given this html:
 * <div class="container"><img src="myawesomeimage" /></div>
 * $('.container').imagefill(); // image stretches to fill container
 *
 * REQUIRES:
 * imagesLoaded - https://github.com/desandro/imagesloaded
 *
 */
;(function($) {

    $.fn.imagefill = function(options) {

        var $container = this,
            imageAspect = 1/1,
            containersH = 0,
            containersW = 0,
            defaults = {
                runOnce: false,
                target: 'img',
                throttle : 200  // 5fps
            },
            settings = $.extend({}, defaults, options);

        var $img = $container.find(settings.target).addClass('loading').css({'position':'absolute'});

        // make sure container isn't position:static
        var containerPos = $container.css('position');
        $container.css({'overflow':'hidden','position':(containerPos === 'static') ? 'relative' : containerPos});

        // set containerH, containerW
        $container.each(function() {
            containersH += $(this).outerHeight();
            containersW += $(this).outerWidth();
        });

        // wait for image to load, then fit it inside the container
        $container.imagesLoadeds().done(function(img) {
            imageAspect = $img.width() / $img.height();
            $img.removeClass('loading');
            fitImages();
            if (!settings.runOnce) {
                checkSizeChange();
            }
        });

        function fitImages() {
            containersH  = 0;
            containersW = 0;
            $container.each(function() {
                imageAspect = $(this).find(settings.target).width() / $(this).find(settings.target).height();
                var containerW = $(this).outerWidth(),
                    containerH = $(this).outerHeight();
                containersH += $(this).outerHeight();
                containersW += $(this).outerWidth();
                var containerAspect = containerW/containerH;
                if (containerAspect < imageAspect) {
                    // taller
                    $(this).find(settings.target).css({
                        width: 'auto',
                        height: containerH,
                        top:0,
                        left:-(containerH*imageAspect-containerW)/2
                    });
                } else {
                    // wider
                    $(this).find(settings.target).css({
                        width: containerW,
                        height: 'auto',
                        top:-(containerW/imageAspect-containerH)/2,
                        left:0
                    });
                }
            });
        }

        function checkSizeChange() {
            var checkW = 0,
                checkH = 0;
            $container.each(function() {
                checkH += $(this).outerHeight();
                checkW += $(this).outerWidth();
            });
            if (containersH !== checkH || containersW !== checkW) {
                fitImages();
            }
            setTimeout(checkSizeChange, settings.throttle);
        }

        return this;
    };

}(jQuery));
